import React from 'react'
import { ProductPackageWithMinAndMaxQuantity } from 'resources/catalog/packages/eventPackage/package/common'
import { intersect } from 'resources/operations/events/utils'
import { ProductPackage } from 'services/api/entities/catalog/packages/common'
import {
  LinkedCustomerUser,
  LinkedOrganization,
} from 'services/api/entities/catalog/types'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { getById } from 'services/utils'
import TailoredFields from 'ui-shared/WrappedInputs/TailoredFields'

type Props<T> = {
  arrayFieldSource: T[]
}

const OrganizationsEmailField = <
  T extends ProductPackageWithMinAndMaxQuantity & {
    customersFull: LinkedCustomerUser[]
    organizationsFull: LinkedOrganization[]
  }
>({
  arrayFieldSource,
}: Props<T>) => {
  const record = useKRecordContext<ProductPackage>()
  if (!record) return null

  const productFull = record.products.map((product) =>
    getById(arrayFieldSource, product.id)
  )
  const onlyWithPrivateOrganizations = productFull.filter(
    (product) =>
      !!product && !!product.organizations && !!product.organizations.length
  )
  const organizationsFull = intersect(
    onlyWithPrivateOrganizations.map((product) => product?.organizationsFull!)
  )
  const newRecord = {
    ...record,
    organizations: organizationsFull.map((c) => c.id),
    organizationsFull,
    customers: [],
    customersFull: [],
  }
  return (
    <TailoredFields
      record={newRecord}
      arrayFieldSource={'organizationsList'}
      chipFieldSource={'name'}
      tailoredListField={'organizationsFull'}
      label={'form.fields.organizations'}
    />
  )
}

export default OrganizationsEmailField
